import { render } from "./cooperate.vue?vue&type=template&id=5154b15a&scoped=true"
import script from "./cooperate.vue?vue&type=script&lang=js"
export * from "./cooperate.vue?vue&type=script&lang=js"

import "./cooperate.vue?vue&type=style&index=0&id=5154b15a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-5154b15a"

export default script